export default __webpack_public_path__ + "static/media/defaultMealImage.f7d848f2.svg";